module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-inverse navbar-fixed-top"
  }, [_c('router-link', {
    attrs: {
      "to": "/app/home",
      "id": "home-button-logo",
      "title": "accueil"
    }
  }, [_c('logo')], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "top-right-hand-corner"
    }
  }, [(_vm.connexionStatus) ? _c('div', {
    attrs: {
      "id": "user-stuff"
    }
  }, [_c('div', {
    attrs: {
      "id": "user-identity"
    }
  }, [(_vm.userName.length && _vm.userSex === 2) ? _c('span', [_vm._v("Mme. " + _vm._s(_vm.userName))]) : _vm._e(), (_vm.userName.length && _vm.userSex === 1) ? _c('span', [_vm._v("M. " + _vm._s(_vm.userName))]) : _vm._e(), _c('br'), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/home"
    }
  }, [_vm._v("Mon espace")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    style: (_vm.currentBgPosition),
    attrs: {
      "id": "nav-buttons"
    }
  }, [(_vm.connexionStatus) ? _c('div', {
    staticStyle: {
      "width": "calc(166px / 2)",
      "height": "80px",
      "position": "absolute",
      "right": "calc(166px / 2)"
    },
    on: {
      "mouseover": function($event) {
        return _vm.spriteTo(80)
      },
      "mouseleave": function($event) {
        return _vm.spriteTo(0)
      }
    }
  }, [_c('router-link', {
    staticClass: "navbar-svg-buttons",
    attrs: {
      "to": "/disconnect",
      "id": "log-out-button",
      "title": "déconnexion"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "8850 -939 50 34.656"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35.268,12.672a8.879,8.879,0,0,0-8.8,8.8,1.333,1.333,0,0,0,2.666,0,6.037,6.037,0,0,1,6.135-6.135H46.2a6.037,6.037,0,0,1,6.135,6.135V38.262a6.264,6.264,0,0,1-6.135,6.4H35.268a6.037,6.037,0,0,1-6.135-6.135,1.333,1.333,0,0,0-2.666,0,8.879,8.879,0,0,0,8.8,8.8H46.2a8.879,8.879,0,0,0,8.8-8.8V21.473a8.879,8.879,0,0,0-8.8-8.8H35.268ZM19,44a1.6,1.6,0,0,0,1.067-.267,1.289,1.289,0,0,0,0-1.867L9.4,31.2H36.867a1.333,1.333,0,0,0,0-2.667H9.4L20.067,17.867A1.32,1.32,0,1,0,18.2,16L5.4,28.8a1.289,1.289,0,0,0,0,1.867l12.8,12.8c.267.533.533.533.8.533Z",
      "transform": "translate(8845 -951.672)"
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(166px / 2)",
      "height": "80px",
      "position": "absolute",
      "right": "0"
    },
    on: {
      "mouseover": function($event) {
        (_vm.connexionStatus) ? _vm.spriteTo(160): _vm.spriteTo(240)
      },
      "mouseleave": function($event) {
        (_vm.connexionStatus) ? _vm.spriteTo(0): _vm.spriteTo(80)
      }
    }
  }, [_c('router-link', {
    staticClass: "navbar-svg-buttons",
    attrs: {
      "to": "/app/home",
      "id": "home-button",
      "title": "accueil"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "8752 -946 50 47.275"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(8752 -946)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M43.5,48.917H28.917V35.375H20.583V48.917H6V27.042a1.042,1.042,0,0,1,2.083,0V46.834H18.5V33.292H31V46.834H41.417V28.083a1.042,1.042,0,1,1,2.083,0Z",
      "transform": "translate(0.25 -1.641)"
    }
  }), _c('path', {
    attrs: {
      "d": "M48.959,28.016a1.039,1.039,0,0,1-.72-.289L25,5.5,1.761,27.728A1.042,1.042,0,0,1,.321,26.222L25,2.616,49.679,26.221a1.042,1.042,0,0,1-.72,1.795Z",
      "transform": "translate(0 -2.616)"
    }
  }), _c('path', {
    attrs: {
      "d": "M39.333,15.375a1.041,1.041,0,0,1-1.042-1.042V8.083h-6.25a1.042,1.042,0,0,1,0-2.083h8.333v8.333A1.041,1.041,0,0,1,39.333,15.375Z",
      "transform": "translate(1.292 -2.475)"
    }
  })])])])], 1)])]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome"
  }, [_vm._v("Bienvenue sur votre espace pub commerçant"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "top-anchor",
      "href": "#top"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ae883ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ae883ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 192
// module chunks = 1